exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-detail-page[data-v-79e991c0]{background:#fafafa!important}", ""]);

// exports
